import swal from 'sweetalert';

(() => {
  angular.module('app').component('commonPatientTicketsDetailSpecialistTreatmentSection', {
    templateUrl: require('./specialistTreatmentSection.component.html'),
    controller: SpecialistTreatmentSectionController,
    controllerAs: 'vm',
    bindings: {
      isReadOnly: '<',
      save: '<',
      onDirtyEvent: '<',
      restoreOriginal: '<',
      isHost: '<',
      ticket: '<',
      hasInsurerClaim: '<',
      hasAlerts: '<',
      coPayAmount: '<',
      hasGpTicketEnhancement: '<',
      isApplyTax: '<',
      countryCode: '<',
      isForeignPatient: '<',
      taxRate: '<',
      onEditAmount: '&',
      onSuccessSave: '&',
      onFinishWithoutSaving: '&',
    },
  });

  SpecialistTreatmentSectionController.$inject = [
    '$uibModal',
    '$scope',
    'Hms.PatientTickets.PatientTicketItem',
  ];

  function SpecialistTreatmentSectionController($modal, $scope, constsPatientTicketItem) {
    const vm = this;

    vm.constsPatientTicketItem = constsPatientTicketItem;

    vm.tempSections = null;
    vm.isHealthScreeningTicket = false;

    vm.specialistV3 = 'V3';
    vm.isViewGrossTaxColumns = vm.specialistV3 && vm.hasGpTicketEnhancement;

    vm.$onInit = $onInit;
    vm.$onChanges = onChanges;
    vm.checkInput = checkInput;
    vm.onDirtyEventHandler = onDirtyEventHandler;
    vm.isTotalBillAmountValid = isTotalBillAmountValid;
    vm.areAmountFieldsValid = areAmountFieldsValid;
    vm.onTaxToggle = onTaxToggle;
    vm.updateItemGrossTaxAmounts = updateItemGrossTaxAmounts;
    vm.isConsultationExemptItem = isConsultationExemptItem;

    init();

    function init() {}

    function $onInit() {
      vm.container = $scope.$parent.vm;
      vm.container.specialistTreatmentSection = vm;
      vm.tempSections = angular.copy(vm.ticket.sections);
      vm.onEditAmount();

      // Set the gross and tax amounts for each treatment category items on load.

      _.forEach(vm.ticket.sections, (section) => {
        _.forEach(section.treatmentCategories, (treatment) => {
          // HM-11174: capture the approval-time exemption from the STORED per-line tax before the
          // recompute, so an amount edit preserves it instead of re-taxing (matches HM-11189).
          treatment.wasConsultationExempt =
            treatment.isConsultation === true
            && Number(treatment.coveredTax || 0) === 0
            && Number(treatment.uncoveredTax || 0) === 0;
          updateItemGrossTaxAmounts(treatment);
        });
      });

      vm.isHealthScreeningTicket = vm.ticket.serviceType === 9;
    }

    function onChanges(changes) {
      if (changes.isReadOnly && !changes.isReadOnly.currentValue) {
        vm.tempSections = angular.copy(vm.ticket.sections);
      }

      if (changes.onDirtyEvent && changes.onDirtyEvent.currentValue) {
        vm.onDirtyEvent.handler = vm.onDirtyEventHandler;
      }

      if (changes.save && !changes.save.isFirstChange()) {
        if (!App.isFormValid($scope.specialistAmountForm) || !vm.isTotalBillAmountValid()) {
          abp.notify.error(App.localize('GeneralInvalidFormInputError'));
          return;
        }

        saveDetails();
      }

      if (changes.restoreOriginal && !changes.restoreOriginal.isFirstChange()) {
        finishWithoutSaving();
      }
    }

    function onDirtyEventHandler() {
      return $scope.specialistAmountForm && $scope.specialistAmountForm.$dirty;
    }

    function finishWithoutSaving() {
      swal(
        {
          title: App.localize('PatientTicketSpecialistDetail_FinishWithoutSavingNarrative'),
          showCancelButton: true,
          closeOnConfirm: false,
          confirmButtonColor: '#1ab394',
        },
        () => {
          vm.ticket.sections = angular.copy(vm.tempSections);
          vm.tempSections = null;
          vm.onEditAmount();
          vm.onFinishWithoutSaving();
          $scope.specialistAmountForm.$setPristine();
          swal.close();
        }
      );
    }

    function saveDetails() {
      $modal
        .open({
          templateUrl: require('../editSpecialistAmount/editSpecialistAmount.modal.html'),
          controller: 'common.views.patientTickets.detail.editSpecialistAmountModal as vm',
          backdrop: 'static',
          resolve: {
            ticket() {
              return vm.ticket;
            },
            totalClaimableAmount() {
              return vm.ticket.totalClaimableAmount;
            },
            coPayAmount() {
              return vm.coPayAmount;
            },
            isForeignPatient() {
              return vm.isForeignPatient;
            },
            isApplyTax() {
              return vm.isApplyTax;
            },
            hasInsurerClaim: vm.hasInsurerClaim,
          },
        })
        .result.then(() => {
          vm.onSuccessSave();
        });
    }

    function checkInput(item) {
      vm.updateItemGrossTaxAmounts(item);
      vm.onEditAmount();
    }

    function isTotalBillAmountValid() {
      let totalBillAmount = 0;
      _.forEach(vm.ticket.sections, (item) => {
        _.forEach(item.treatmentCategories, (d) => {
          totalBillAmount += (d.coveredAmount || 0) + (d.uncoveredAmount || 0);
        });
      });

      const totalAmount = vm.ticket.totalClaimableAmount !== undefined 
        ? vm.ticket.totalClaimableAmount
        : vm.ticket.amount;

      return vm.areAmountFieldsValid()
        ? totalAmount === App.roundAmount(totalBillAmount)
        : false;
    }

    function areAmountFieldsValid() {
      let isValid = true;

      _.forEach(vm.ticket.sections, (item) => {
        _.forEach(item.treatmentCategories, (d) => {
          if (
            typeof d.coveredAmount === 'undefined' ||
            d.amount === null ||
            typeof d.uncoveredAmount === 'undefined' ||
            d.uncoveredAmount === null
          ) {
            isValid = false;
          }
        });
      });
      return isValid;
    }

    function onTaxToggle() {
      if (!vm.ticket) return;

      _.forEach(vm.ticket.sections, (section) => {
        if (!section.treatmentCategories) return;
        _.forEach(section.treatmentCategories, (item) => {
          vm.updateItemGrossTaxAmounts(item);
        });
      });
    }

    // Whether this consultation line was exempt at approval, captured on load from the stored
    // per-line tax (see $onInit). The amount edit preserves that decision instead of re-deriving
    // from the flag, so editing never moves the SST split (matches HM-11189). [HM-11174]

    function isConsultationExemptItem(item) {
      return !!item && item.wasConsultationExempt === true;
    }

    function updateItemGrossTaxAmounts(item) {
      if (vm.isReadOnly)
        return;

      const covered = Number(item.coveredGross);
      const uncovered = Number(item.uncoveredGross);

      // Check if applying tax.
      // If not (or this is the by-rule exempt consultation), set the amount to the gross amount.

      if (!vm.isApplyTax
        || (vm.countryCode !== 'MY' || !vm.isForeignPatient)
        || isConsultationExemptItem(item)
      ) {
        item.coveredAmount = covered;
        item.uncoveredAmount = uncovered;

        // Reset the tax values if tax application toggled off.

        item.coveredTax = 0;
        item.uncoveredTax = 0;
      }
      else {
        // SST 6% for foreigners.
        const taxRate = vm.taxRate / 100;

        item.coveredTax = App.evenRound(covered * taxRate, 2);
        item.coveredAmount = App.evenRound(covered + item.coveredTax, 2);
      
        item.uncoveredTax = App.evenRound(uncovered * taxRate, 2);
        item.uncoveredAmount = App.evenRound(uncovered + item.uncoveredTax, 2);
      }
    }

  }
})();
